export const editAccount = `query editAccount($id: ID!) {
  getAccount(id: $id) {
    id
    name
    nameLegal
    namePrevious
    status
    premier
    IPCorp
    createdAt
    ownershipType
    processorId
    approvalDate
    underwritingStatus
    nameDba
    phoneBusiness
    phoneSupport
    phoneFax
    ein
    alert    
    addressMailing
    addressPhysical
    bankAccount
    accountCompanyId
    company {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      active
      accounts {
        nextToken
      }
    }
    services {
      items {
        id
        name
        description
        pilot
        merchantNumber
        email
        createdAt
      }
      nextToken
    }
    persons {
      items {
        id
        person {
          id
          given_name
          family_name
          email
          createdAt
        }
        account {
          id
          name
          accountCompanyId
          createdAt
        }
        createdAt
      }
      nextToken
    }
  },
  listOwnershipTypeEnum: __type(name: "OwnershipType") {
    enumValues {
      name
    }
  },
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  },
  listPersonAccountRoleEnum: __type(name: "PersonAccountRole") {
    enumValues {
      name
    }
  }
}
`;

export const listAccountCompanies = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;

export const newAccount = `query newAccount {
  listOwnershipTypeEnum: __type(name: "OwnershipType") {
    enumValues {
      name
    }
  }
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editService = `query editService($id: ID!) {
  getService(id: $id) {
    id
    name
    nameLegal
    description
    pilot
    merchantNumber
    email
    website
    phone
    phoneExt
    status
    processorId
    approvalDate
    underwritingStatus
    IPCorp
    serviceType
    bankAccount
    withdrawalAccount
    addressPhysical
    addressMailing
    createdAt
    updatedAt
    isRestructured
    isWithdrawalAccount
    wbankName
    wbankRouting
    wbankAccount
    nameDba
    processor
    proposalStatementValue
    phoneBusiness
    phoneSupport
    phoneFax
    ein
    alertMessage
    ownershipType
    avgTrxAmount
    totalCashCreditSalesMonthly
    estAvgMcVisaTicketSaleAmount
    volumeMcVisaOutletMonthly
    dateUwResult
    dateContractExt
    uwResult
    dateOpen
    dateClosed
    businessType
    busSicCode
    busSicCodeDesc
    busProductsSold
    busSalesLimitM
    busTicketAvg
    busTicketMax
    busSwipePct
    busKeyPct
    busWebPct
    busMailPct
    busAgeY
    busAgeM
    busBusToBus
    busBusToCon
    busLocationCnt
    busSeasonOn
    busSeasonM
    busSeasonOpenM
    busSeasonCloseM
    amex
    amexNum
    discover
    discoverNum
    wexVoyagerOn
    wexVoyagerId
    esaId
    ebtFnsNum
    ebtCashOn
    checkServiceVendor
    checkServiceNum
    giftVendor
    giftVendorNum
    debitPinOn
    cashCreditSalesM
    mcVisaSaleAvg
    mcVisaVolM
    checksCntAvgM
    owner
    closeRequested
    closeDate
    closeReason
    closeReasonDetails
    closeEtfAmountRes
    closeCancelFee
    closeResReportDate
    closeEtfAmount
    closeEtfAdjust
    closeEtfRefundAmount
    closeEtfRefundDate
    closeEtfChargedDate
    closeEtfWaiveReason
    closeEtfWaiveOther
    closeResReportRefundDate
    beta
    pendingResponsibility
    dateSubmitted
    dateFirstProcessing
    declineReason
    declineNotes
    annualAmount
    annualAmountPCI
    altMonthMinAmount
    comments(limit: 9999) {
      items {
        id
        comment
        internal
        createdAt
        updatedAt
        parentComment {
          id
        }
        user {
          id
          email
          given_name
          family_name
        }
        comments(limit: 9999) {
          items {
            id
            comment
            internal
            createdAt
            updatedAt
            user {
              id
              email
              given_name
              family_name
            }
          }
          nextToken
        }
      }
      nextToken
    }
    account {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert      
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        active
      }
      services {
        nextToken
      }
    }
    cases(limit: 999) {
      items {
        id
        owner
        createdAt
        updatedAt
        service {
          id
          name
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          rushReason
          quickNote
          createdAt
          updatedAt
          owner
          person {
            id
            given_name
            family_name
            email
          }
          owner
          team {
            id
            name
          }
          accounts {
            items {
              id
              createdAt
              owner
              account {
                id
                name
                status
                createdAt
                owner
              }
            }
            nextToken
          }
          services {
            items {
              id
              service {
                id
                name
                merchantNumber
              }
            }
            nextToken
          }
          products {
            items {
              id
              product {
                id
                name
              }
            }
            nextToken
          }
          companies {
            items {
              id
              company {
                id
                name
              }
            }
            nextToken
          }
          salesreps {
            items {
              id
              salesrep {
                id
                given_name
                family_name
              }
            }
            nextToken
          }
          user {
            id
            email
            given_name
            family_name
          }
          tasks(limit: 999) {
            items {
              id
              isAvailable
              subject
              status
              internal
              dateDue
              group
              case {
                id
                name
                status
                internal
                origin
                type
                dateDue
                priority
                quickNote
                createdAt
                updatedAt
                owner
                services(limit: 999) {
                  items {
                    id
                    owner
                    createdAt
                    updatedAt
                  }
                  nextToken
                }
              }
              user {
                id
                email
                given_name
                family_name
              }
              steps {
                items {
                  id
                  title
                  description
                  order
                  status
                  isAvailable
                  owner
                  createdAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  comment
                  internal
                  createdAt
                  updatedAt
                  owner
                  atMentions
                  user {
                    id
                    email
                    given_name
                    family_name
                    owner
                  }
                  parentComment {
                    id
                    comment
                    internal
                    createdAt
                    updatedAt
                    owner
                    atMentions
                  }
                  comments {
                    items {
                      id
                      comment
                      internal
                      createdAt
                      updatedAt
                      owner
                      atMentions
                      user {
                        id
                        email
                        given_name
                        family_name
                        owner
                      }
                    }
                  }
                }
                nextToken
              }
            }
            nextToken
          }
          messages(limit: 999) {
            items {
              id
              subject
              from
              to
              cc
              bcc
              body
              internal
              replyToMessageId
              outgoingFlag
              
              messageAttachmentId
              createdAt
              updatedAt
              user {
                id
                email
                given_name
                family_name
                owner
              }
              person {
                id
                email
                given_name
                family_name
                owner
              }
              comments(limit: 999) {
                items {
                  id
                  comment
                  internal
                  createdAt
                  updatedAt
                  owner
                  user {
                    id
                    email
                    given_name
                    family_name
                    middle_name
                    owner
                  }
                }
                nextToken
              }
            }
            nextToken
          }
          notes(limit: 999) {
            items {
              id
              note
              owner
              internal
              createdAt
              updatedAt
              user {
                id
                email
                given_name
                family_name
                middle_name
                owner
              }
              comments(limit: 999) {
                items {
                  id
                  comment
                  internal
                  createdAt
                  updatedAt
                  owner
                  user {
                    id
                    email
                    given_name
                    family_name
                    middle_name
                    owner
                  }
                }
                nextToken
              }
            }
            nextToken
          }
          caseDrafts {
            items {
              id
              subject
              from
              to
              cc
              bcc
              body
              messageCaseId
              internal
              owner
              draftType
              replyToMessageId
              createdAt
              updatedAt
            }
            nextToken
          }
          template {
            id
            name
            subject
          }
        }
      }
    }
    portfolios {
      items {
        id
        portfolio {
          id
          name
          createdAt
        }
        createdAt
      }
      nextToken
    }
    products {
      items {
        id
        product {
          id
          name
          createdAt
        }
        createdAt
      }
      nextToken
    }
    closeEtfWaiveAppover {
      id
      email
      given_name
      family_name
    }
  }
  listProcessorTypeEnum: __type(name: "ProcessorType") {
    enumValues {
      name
    }
  }
  listServiceStatuseEnum: __type(name: "ServiceStatuse") {
    enumValues {
      name
    }
  }
  listOwnershipTypeEnum: __type(name: "OwnershipType") {
    enumValues {
      name
    }
  }
  listBusinessTypeEnum: __type(name: "BusinessType") {
    enumValues {
      name
    }
  }
  listAmexCardTypeEnum: __type(name: "AmexCardType") {
    enumValues {
      name
    }
  }
  listDiscoverCardTypeEnum: __type(name: "DiscoverCardType") {
    enumValues {
      name
    }
  }
  listEsaIdTypeEnum: __type(name: "EsaIdType") {
    enumValues {
      name
    }
  }
  listCheckServiceVendorEnum: __type(name: "CheckServiceVendor") {
    enumValues {
      name
    }
  }
  listGiftVendorEnum: __type(name: "GiftVendor") {
    enumValues {
      name
    }
  }
  listServiceCloseReasonEnum: __type(name: "ServiceCloseReason") {
    enumValues {
      name
    }
  }  
  listServiceCloseCancelFeeEnum: __type(name: "ServiceCloseCancelFee") {
    enumValues {
      name
    }
  }   
  listServiceCloseEtfWaiveReasonEnum: __type(name: "ServiceCloseEtfWaiveReason") {
    enumValues {
      name
    }
  }      
  listUsers(limit: 999, filter: null) {
    items {
      id
      email
      given_name
      family_name
    }
  }
  listPendingResponsibilityEnum: __type(name: "PendingResponsibility") {
    enumValues {
      name
    }
  }
  listDeclineReasonEnum: __type(name: "DeclineReason") {
    enumValues {
      name
    }
  }
  listServiceTypeEnum: __type(name: "ServiceType") {
    enumValues {
      name
    }
  }
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const listServiceAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;

export const editPortfolio = `query GetPortfolio($id: ID!) {
  getPortfolio(id: $id) {
    id
    name
    description
    premier
    status
    services {
      items {
        id
        service {
          id
          name
          createdAt
        }
        createdAt
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;

export const editTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      id
      name
      cognito_groupid
      owner
      createdAt
      updatedAt
      users {
        items {
          id
          user {
            id
            email
            createdAt
          }
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;

export const newService = `query newService {
  listProcessorTypeEnum: __type(name: "ProcessorType") {
    enumValues {
      name
    }
  }
  listServiceStatuseEnum: __type(name: "ServiceStatuse") {
    enumValues {
      name
    }
  }
  listOwnershipTypeEnum: __type(name: "OwnershipType") {
    enumValues {
      name
    }
  }
  listBusinessTypeEnum: __type(name: "BusinessType") {
    enumValues {
      name
    }
  }
  listAmexCardTypeEnum: __type(name: "AmexCardType") {
    enumValues {
      name
    }
  }
  listDiscoverCardTypeEnum: __type(name: "DiscoverCardType") {
    enumValues {
      name
    }
  }
  listEsaIdTypeEnum: __type(name: "EsaIdType") {
    enumValues {
      name
    }
  }
  listCheckServiceVendorEnum: __type(name: "CheckServiceVendor") {
    enumValues {
      name
    }
  }
  listGiftVendorEnum: __type(name: "GiftVendor") {
    enumValues {
      name
    }
  }
  listServiceCloseReasonEnum: __type(name: "ServiceCloseReason") {
    enumValues {
      name
    }
  }  
  listServiceCloseCancelFeeEnum: __type(name: "ServiceCloseCancelFee") {
    enumValues {
      name
    }
  }   
  listServiceCloseEtfWaiveReasonEnum: __type(name: "ServiceCloseEtfWaiveReason") {
    enumValues {
      name
    }
  } 
  listUsers(limit: 999, filter: null) {
    items {
      id
      email
      given_name
      family_name
    }
  }
  listPendingResponsibilityEnum: __type(name: "PendingResponsibility") {
    enumValues {
      name
    }
  }
  listDeclineReasonEnum: __type(name: "DeclineReason") {
    enumValues {
      name
    }
  }
  listServiceTypeEnum: __type(name: "ServiceType") {
    enumValues {
      name
    }
  }
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editCaseTemplate = `query GetCaseTemplate($id: ID!) {
  getCaseTemplate(id: $id) {
    id
    name
    status
    internal
    isCompleteInOrder
    subject
    origin
    type
    dateDue
    priority
    hasWorkflow
    createdAt
    updatedAt
    owner
    team {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        nextToken
      }
      users {
        nextToken
      }
    }
    tasks {
      items {
        id
        isTemplate
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        priority       
        status
        dateCompleted
        user {
          id
          email
          given_name
          family_name
          middle_name
        }
        steps {
          items {
            id
            title
            description
            order
            status
            isAvailable
            owner
            createdAt
          }
          nextToken
        }
      }
      nextToken
    }
  },
  listCaseOriginEnum: __type(name: "CaseOrigin") {
    enumValues {
      name
    }
  },
  listCaseStatusEnum: __type(name: "CaseStatus") {
    enumValues {
      name
    }
  },
  listCaseTypeEnum: __type(name: "CaseType") {
    enumValues {
      name
    }
  },
  listCasePriorityEnum: __type(name: "CasePriority") {
    enumValues {
      name
    }
  },
}
`;

export const editHq = `query GetHq($id: ID!) {
  getHQ(id: $id) {
    id
    name
    createdAt
    updatedAt
    owner
    IPCorp
    active
    companies {
      items {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        active
        createdAt
        owner
      }
      nextToken
    }
  }
}
`;

export const editSalesOffice = /* GraphQL */ `
  query GetSalesOffice($id: ID!) {
    getSalesOffice(id: $id) {
      id
      name
      active
      owner
      createdAt
      updatedAt
    }
  }
`;

export const listCompanyAccountServices = `query ListCompanyAccountServices(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
  $servicesFilter: ModelServiceFilterInput
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      services(filter: $servicesFilter) {
        items {
          id
          name
          status
        }
        nextToken
      }
    }
    nextToken
  }
}
`;

export const listAccountServiceProducts = `query ListAccountServiceProducts(
  $filter: ModelServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
    }
    nextToken
  }
}
`;

export const listCompanyAccounts = `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert     
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
    }
    nextToken
  }
}
`;

export const editCase = `query editCase(
    $id: ID! $messagesLimit: Int, 
    $notesLimit: Int, 
    $personLimit: Int,
    $usersLimit: Int,
    $caseTemplatesLimit: Int,
    $changeLimit: Int,
    $commentsFilter: ModelCommentFilterInput,
    $messagesFilter: ModelMessageFilterInput,
    $notesFilter: ModelNoteFilterInput,
    $caseTemplatesFilter: ModelCaseTemplateFilterInput,
    $caseLinksFilter: SearchableCaseLinkFilterInput
  ) {
  getCase(id: $id) {
    id
    name
    subject
    status
    internal
    isCompleteInOrder
    alertMessage
    origin
    type
    dateDue
    closedDate
    priority
    rushReason
    quickNote
    isSystemCreated
    createdAt
    updatedAt
    owner
    person {
      id
      given_name
      family_name
      email
    }
    owner
    team {
      id
      name
    }
    accounts {
      items {
        id
        createdAt
        owner
        account {
          id
          name
          status
          createdAt
          owner
        }
      }
      nextToken
    }
    services {
      items {
        id
        service {
          id
          name
          merchantNumber
        }
      }
      nextToken
    }
    products {
      items {
        id
        product {
          id
          name
        }
      }
      nextToken
    }
    companies {
      items {
        id
        company {
          id
          name
        }
      }
      nextToken
    }
    salesreps {
      items {
        id
        salesrep {
          id
          given_name
          family_name
        }
      }
      nextToken
    }
    user {
      id
      email
      given_name
      family_name
    }
    tasks(limit: 999) {
      items {
        id
        isAvailable
        isCompleteInOrder
        dateDue
        subject
        internal
        group
        order
        status
        case {
          id
          name
          status
          internal
          origin
          type
          dateDue
          priority
          quickNote
          createdAt
          updatedAt
          owner
          services(limit: 999) {
            items {
              id
              owner
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        user {
          id
          email
          given_name
          family_name
        }
        steps {
          items {
            id
            title
            description
            order
            status
            isAvailable
            owner
            createdAt
          }
          nextToken
        }
        comments {
          items {
            id
            comment
            internal
            createdAt
            updatedAt
            owner
            atMentions
            user {
              id
              email
              given_name
              family_name
              owner
            }
            parentComment {
              id
              comment
              internal
              createdAt
              updatedAt
              owner
              atMentions
            }
            comments {
              items {
                id
                comment
                internal
                createdAt
                updatedAt
                owner
                atMentions
                user {
                  id
                  email
                  given_name
                  family_name
                  owner
                }
              }
            }
          }
          nextToken
        }
      }
      nextToken
    }
    messages(limit: $messagesLimit, filter: $messagesFilter) {
      items {
        id
        subject
        from
        to
        cc
        bcc
        body
        internal
        replyToMessageId
        outgoingFlag
        
        messageAttachmentId
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          owner
        }
        person {
          id
          email
          given_name
          family_name
          owner
        }
        comments(limit: $notesLimit, filter: $commentsFilter) {
          items {
            id
            comment
            internal
            createdAt
            updatedAt
            owner
            user {
              id
              email
              given_name
              family_name
              middle_name
              owner
            }
          }
          nextToken
        }
      }
      nextToken
    }
    notes(limit: $notesLimit, filter: $notesFilter) {
      items {
        id
        note
        owner
        internal
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          owner
        }
        comments(limit: $notesLimit, filter: $commentsFilter) {
          items {
            id
            comment
            internal
            createdAt
            updatedAt
            owner
            user {
              id
              email
              given_name
              family_name
              middle_name
              owner
            }
          }
          nextToken
        }
      }
      nextToken
    }
    caseDrafts {
      items {
        id
        subject
        from
        to
        cc
        bcc
        body
        messageCaseId
        internal
        owner
        draftType
        replyToMessageId
        createdAt
        updatedAt
      }
      nextToken
    }
    template {
      id
      name
      subject
    }
  },
  listCaseOriginEnum: __type(name: "CaseOrigin") {
    enumValues {
      name
    }
  },
  listCaseStatusEnum: __type(name: "CaseStatus") {
    enumValues {
      name
    }
  },
  listCaseTypeEnum: __type(name: "CaseType") {
    enumValues {
      name
    }
  },
  listCasePriorityEnum: __type(name: "CasePriority") {
    enumValues {
      name
    }
  },
  searchChanges(limit: $changeLimit, filter: {and: [{modelName: {eq: "Case"}}, {modelId: {eq: $id}}]}) {
    items {
      id
      owner
      createdAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
      }
    }
    nextToken
  },
  listCaseTemplates(limit: $caseTemplatesLimit, filter: $caseTemplatesFilter) {
    items {
      id
      name
      status
      internal
      isCompleteInOrder
      subject
      origin
      type
      dateDue
      priority
      hasWorkflow
      createdAt
      updatedAt
      owner
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        updatedAt
      }
      tasks {
        items {
          id
          isTemplate
          type
          dateDue
          subject
          internal
          isAvailable
          isCompleteInOrder
          owner
          group
          order
          createdAt
          priority
          status
          dateCompleted
          case {
            id
            name
            subject
            status
            internal
            origin
            type
            dateDue
            priority
            createdAt
            updatedAt
            owner
            team {
              id
              name
              cognito_groupid
              owner
              createdAt
              updatedAt
            }
          }
          user {
            id
            email
            given_name
            family_name
            middle_name
            nickname
            picture
            gender
            birthdate
            zoneinfo
            phone_number
            address
            source
            createdAt
            updatedAt
            cogUsername
            cogUserCreateDate
            cogUserLastModifiedDate
            cogEnabled
            cogUserStatus
            cogEmailVerified
            cogPreferredMfaSetting
            cogUserMFASettingList
            owner
          }
          steps {
            items {
              id
              title
              description
              order
              status
              isAvailable
              owner
              createdAt
            }
            nextToken
          }
        }
      }
    }
  },
  listUsers(limit: $usersLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
      middle_name
    }
  },
  listPersons(limit: $personLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
    }
  },
  searchCaseLinks(filter: $caseLinksFilter) {
    items {
      id
      case{
        id 
        subject
      }
      linkCase{
        id 
        subject
      }
      reason
      esData
      esSync
    }
  },
}
`;

export const newCase = `query newCase(
  
  $usersLimit: Int,
  $caseTemplatesLimit: Int,
  $caseTemplatesFilter: ModelCaseTemplateFilterInput,
) {
  listAccounts(filter: null) {
    items {
      id
      name
      status
    }
  },
  listServices(filter: null) {
    items {
      id
      name
      status
    }
  },
  listCaseOriginEnum: __type(name: "CaseOrigin") {
     enumValues {
       name
     }
  },
  listCaseStatusEnum: __type(name: "CaseStatus") {
     enumValues {
       name
     }
  },
  listCaseTypeEnum: __type(name: "CaseType") {
     enumValues {
       name
     }
  },
  listCasePriorityEnum: __type(name: "CasePriority") {
     enumValues {
       name
     }
  },
  listCaseTemplates(limit: $caseTemplatesLimit, filter: $caseTemplatesFilter) {
    items {
      id
      name
      status
      internal
      isCompleteInOrder
      subject
      origin
      type
      dateDue
      priority
      hasWorkflow
      createdAt
      updatedAt
      owner
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        updatedAt
      }
      tasks {
        items {
          id
          isTemplate
          type
          dateDue
          subject
          internal
          isAvailable
          isCompleteInOrder
          owner
          group
          order
          createdAt
          priority
          status
          dateCompleted
          case {
            id
            name
            subject
            status
            internal
            origin
            type
            dateDue
            priority
            createdAt
            updatedAt
            owner
            team {
              id
              name
              cognito_groupid
              owner
              createdAt
              updatedAt
            }
          }
          user {
            id
            email
            given_name
            family_name
            middle_name
            nickname
            picture
            gender
            birthdate
            zoneinfo
            phone_number
            address
            source
            createdAt
            updatedAt
            cogUsername
            cogUserCreateDate
            cogUserLastModifiedDate
            cogEnabled
            cogUserStatus
            cogEmailVerified
            cogPreferredMfaSetting
            cogUserMFASettingList
            owner
          }
          steps {
            items {
              id
              title
              description
              order
              status
              isAvailable
              owner
              createdAt
            }
            nextToken
          }
        }
      }
    }
  },
  listUsers(limit: $usersLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
      middle_name
    }
  }
}
`;

export const newCaseTemplate = `query newCase {
  listCaseOriginEnum: __type(name: "CaseOrigin") {
     enumValues {
       name
     }
  },
  listCaseStatusEnum: __type(name: "CaseStatus") {
     enumValues {
       name
     }
  },
  listCaseTypeEnum: __type(name: "CaseType") {
     enumValues {
       name
     }
  },
  listCasePriorityEnum: __type(name: "CasePriority") {
     enumValues {
       name
     }
  },
}
`;

export const editCompany = `query editCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    premier
    email
    website
    phone
    phoneExt
    IPCorp
    alertMessage
    active
    accounts {
      items {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert        
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        services {
          items {
            id
            name
            status
          }
        }
      }
      nextToken
    }
    persons {
      items {
        id,
        person {
          id
          given_name
          family_name
          email
        }
      }
      nextToken
    }
  },
  
}
`;

export const newSalesRep = `query newSalesRep {
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editSalesRep = `query GetSalesRep($id: ID!) {
  getSalesRep(id: $id) {
    id
    given_name
    family_name
    nickname
    website
    email
    email_verified
    zoneinfo
    locale
    phone_number
    phone_number_verified
    addressMailing
    createdAt
    updatedAt
    description
    premier
    cognito_userid
  }
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editTask = `query GetTask($id: ID!, $usersLimit: Int, $casesLimit: Int, $changesLimit: Int, $commentsLimit: Int) {
  getTask(id: $id) {
    id
    isTemplate
    isAvailable
    isCompleteInOrder
    order
    group
    type
    dateDue
    subject
    internal
    owner
    createdAt
    priority
    quickNote
    status
    hasWorkflow
    isSystemCreated
    taskTemplate {
      id
      subject
    }
    case {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      quickNote
      createdAt
      updatedAt
      owner
      tasks {
        nextToken
      }
      messages {
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          service {
            id
            name
            description
            pilot
            status
            owner
            merchantNumber
            createdAt
          }
        }
        nextToken
      }
    }
    user {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      createdAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      tasks {
        nextToken
      }
    }
    steps {
      items {
        id
        title
        description
        order
        isAvailable
        status
        owner
        createdAt
      }
      nextToken
    }
    accounts {
      items {
        id
        createdAt
        owner
        account {
          id
          name
          status
          createdAt
          owner
        }
      }
      nextToken
    }
    services {
      items {
        id
        createdAt
        owner
        service {
          id
          name
          description
          pilot
          status
          owner
          createdAt
        }
      }
      nextToken
    }
    products {
      items {
        id
        createdAt
        owner
        product {
          id
          name
          description
          status
          owner
          createdAt
        }
      }
      nextToken
    }
    companies {
      items {
        id
        owner
        createdAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          createdAt
          owner
        }
      }
      nextToken
    }
    salesreps {
      items {
        id
        owner
        createdAt
        updatedAt
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
  searchUsers(limit: $usersLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
      middle_name
    }
  }
  searchCases(limit: $casesLimit, filter: null) {
    items {
      id
      name
      subject
      status
    }
  }
  searchChanges(limit: $changesLimit, filter: {and: [{modelName: {eq: "Task"}}, {modelId: {eq: $id}}]}) {
    items {
      id
      owner
      createdAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        owner
      }
    }
    nextToken
  }
  searchComments(limit: $commentsLimit, filter: { commentTaskId: { eq: $id }}) {
    items {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      user {
        id
        email
        given_name
        family_name
        middle_name
        owner
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
          user {
            id
            email
            given_name
            family_name
            middle_name
            owner
          }
        }
        nextToken
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
    }
    nextToken
  }
}
`;

export const newPerson = `query newPerson {
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editPerson = `query GetPerson($id: ID!) {
  getPerson(id: $id) {
    id
    given_name
    middle_name
    family_name
    nickname
    website
    email
    email_verified
    zoneinfo
    locale
    phone_number
    phone_number_verified
    phone_mobile
    phone_other
    phone_home
    fax_number
    addressHome
    addressOther
    ssn
    dob
    dl_number    
    createdAt
    description
    premier
    cognito_userid
    companys {
      items {
        id
        person {
          id
          given_name
          family_name
          email
          createdAt
        }
        company {
          id
          name
          createdAt
        }
        createdAt
      }
      nextToken
    }
    accounts {
      items {
        id
        createdAt
        person {
          id
          given_name
          family_name
          email
          createdAt
        }
        account {
          id
          name
          accountCompanyId
          createdAt
        }
      }
      nextToken
    }
  }
  listStatesEnum: __type(name: "States") {
    enumValues {
      name
    }
  }
  listCountriesEnum: __type(name: "Countries") {
    enumValues {
      name
    }
  }
}
`;

export const editProduct = `query editProduct($id: ID!) {
  getProduct(id: $id) {
    id
    name
    description
    status
    billingMethod
    serial
    platform
    appType
    connect
    conversion
    encryptionKey
    purchaseSwap
    feeMonthly
    cashDiscount
    owner
    virtualTerminal
    accountVault
    recurring
    customerSignUp
    authNetEmulator
    multMerchantMultiDeposit
    multiMerchantNumber
    notesComments
    setupFee
    perItemFee
    terminalOrTsysId
    midV
    storeNumber
    url
    usernames
    gatewayId
    vendorContactNotes
    conversionSetupCost
    soldAmount
    warrantyReplacement
    replacementDate
    isPinPad
    pinPadPurchaseAmount
    FPPPinMonthlyFee
    pabx
    staticIp
    dns1
    gatewayIp
    subnet
    dns2
    secureFileCheck
    securityLevel
    tipLine
    counterTip
    serverNumer
    autoCloseTime
    giftCardProvider
    ebt
    avs
    checkProviderNumber
    fraud
    merchantNumber
    purchaseCard
    taxId
    downloadPhone
    portNumber
    deviceId
    emvSmartCard
    nfc
    autoClose
    giftCards
    internalPinPad
    checkServices
    cvv2
    multiMerchant
    invoiceNumber
    customerCode
    createdAt
    account {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        createdAt
        owner
      }
      services {
        nextToken
      }
      products {
        nextToken
      }
      persons {
        nextToken
      }
      cases {
        nextToken
      }
    }
    billToService {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
      }
      portfolios {
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
      }
      products {
        nextToken
      }
      cases {
        nextToken
      }
    }
    services {
      items {
        id
        owner
        createdAt
        service {
          id
          name
          description
          pilot
          status
          owner
          createdAt
        }
      }
      nextToken
    }
    children {
      items {
        id
        owner
        createdAt
        updatedAt
        required
        child {
          id
          name
          owner
          createdAt
          updatedAt
          productOption {
            id
            name
            category
            brand
            legacyName
            status
            createdAt
            owner
          }
          status
          children {
            items {
              id
              owner
              createdAt
              updatedAt
              required
              child {
                id
                name
                owner
                createdAt
                updatedAt
                status
                productOption {
                  id
                  name
                  category
                  brand
                  legacyName
                  status
                  createdAt
                  owner
                }
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
    productOption {
      id
      name
      category
      brand
      legacyName
      status
      createdAt
      products {
        nextToken
      }
      owner
      children {
        items {
          id
          child {
            id
            name
          }
        }
      }
    }
    cases {
      items {
        id
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  },
  listAccounts(filter: null) {
    items {
      id
      name
      status
    }
    nextToken
  },
  listServices(filter: null) {
    items {
      id
      name
      status
      account {
        id
        name
      }
    }
  },
  listProductOptions(filter: null, limit: 999) {
    items {
      id
      name
      category
      status
      children {
        items {
          id
          owner
          createdAt
          updatedAt
          required
          child {
            id
            name
            status
            category
            children {
              items {
                id
                owner
                createdAt
                updatedAt
                required
                child {
                  id
                  name
                  status
                  category
                }
              }
            }
          }
          
        }
      }
    }
    nextToken
  },
  listProductCategoryEnum: __type(name: "ProductCategory") {
    enumValues {
      name
    }
  },  
  listProductBillingMethodEnum: __type(name: "ProductBillingMethod") {
    enumValues {
      name
    }
  }, 
  listProductPlatformEnum: __type(name: "ProductPlatform") {
    enumValues {
      name
    }
  }, 
  listProductAppTypeEnum: __type(name: "ProductAppType") {
    enumValues {
      name
    }
  },  
  listProductConnectEnum: __type(name: "ProductConnect") {
    enumValues {
      name
    }
  },
  listProductConversionEnum: __type(name: "ProductConversion") {
    enumValues {
      name
    }
  },
  listProductEncryptionKeyEnum: __type(name: "ProductEncryptionKey") {
    enumValues {
      name
    }
  },
  listProductPurchaseSwapEnum: __type(name: "ProductPurchaseSwap") {
    enumValues {
      name
    }
  },
  listProductFeeMonthlyEnum: __type(name: "ProductFeeMonthly") {
    enumValues {
      name
    }
  }
}
`;

export const listProductProductOptions = /* GraphQL */ `
  query ListProductOptions(
    $filter: ModelProductOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items { 
        id
        name
        category
        status
      }
      nextToken
    }
  }
`;

export const searchServiceProductsCustoms = /* GraphQL */ `
  query SearchProductServices(
    $filter: SearchableProductServiceFilterInput
    $sort: SearchableProductServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        product {
          id
          name
          description
          status
          billingMethod
          billToService {
            id
            name
          }
          serial
          platform
          terminalOrTsysId
          midV
          replacementDate
          merchantNumber
          createdAt
          productOption {
            id
            name
            category
          }
          children {
            items {
              id
              owner
              createdAt
              updatedAt
              required
              child {
                id
                name
                status
                platform
                terminalOrTsysId
                midV
                billingMethod
                serial
                replacementDate
                owner
                createdAt
                productOption {
                  id
                  name
                  category
                }
                children {
                  items {
                    id
                    owner
                    createdAt
                    updatedAt
                    required
                    child {
                      id
                      name
                      status
                      platform
                      terminalOrTsysId
                      midV
                      billingMethod
                      serial
                      replacementDate
                      owner
                      createdAt
                      productOption {
                        id
                        name
                        category
                      }
                    }
                  }
                  nextToken
                }
              }
            }
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;

export const searchProductsChildrens = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        billingMethod
        serial
        platform
        midV
        terminalOrTsysId
        replacementDate
        createdAt
        account {
          id
          name
          status
          createdAt
        }
        billToService {
          id
          name
          status
          createdAt
        }
        children {
          items {
            id
            owner
            createdAt
            updatedAt
            required
            child {
              id
              name
              status
              platform
              terminalOrTsysId
              midV
              billingMethod
              serial
              replacementDate
              owner
              createdAt
              children {
                items {
                  id
                  owner
                  createdAt
                  updatedAt
                  required
                  child {
                    id
                    name
                    status
                    platform
                    terminalOrTsysId
                    midV
                    billingMethod
                    serial
                    replacementDate
                    owner
                    createdAt
                  }
                }
                nextToken
              }
              productOption {
                id
                name
                category
              }
            }
          }
          nextToken
        }
        productOption {
          id
          name
          category
          status
          createdAt
        }
      }
      nextToken
      total
    }
  }
`;

export const searchRelatedProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        productOption {
          id
          name
          category
          status
          createdAt
        }
      }
      nextToken
      total
    }
  }
`;

export const newProductOption = `query newProductOption {
  listProductCategoryEnum: __type(name: "ProductCategory") {
    enumValues {
      name
    }
  },
  listProductBrandEnum: __type(name: "ProductBrand") {
    enumValues {
      name
    }
  }
}
`;

export const searchProductOptionCustoms = /* GraphQL */ `
  query SearchProductOptions(
    $filter: SearchableProductOptionFilterInput
    $sort: SearchableProductOptionSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductOptions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        category
        createdAt
        children {
          items {
            id
            required
            child {
              id
              name
              category
              status
              createdAt
            }
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;


export const getProductOptionCustoms = /* GraphQL */ `
  query GetProductOption($id: ID!) {
    getProductOption(id: $id) {
      id
      name
      category
    }
  }
`;

export const getProductCustoms = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      status
      serial
      productOption {
        id
        name
      }
    }
  }
`;

export const editProductOption = `query editProductOption(
  $id: ID!
  $productOptionChildFilter: SearchableProductOptionChildFilterInput
  ) {
      getProductOption(id: $id) {
        id
        name
        category
        brand
        legacyName
        status
        notes
        createdAt
        owner,
        children {
          items {
            id
            owner
            createdAt
            updatedAt
            required
            child {
              id
              name
              owner
              createdAt
              updatedAt
              status
              category
            }
          }
          nextToken
        }
      },
      listProductCategoryEnum: __type(name: "ProductCategory") {
        enumValues {
          name
        }
      },
      listProductBrandEnum: __type(name: "ProductBrand") {
        enumValues {
          name
        }
      },
      searchProductOptionChilds(filter: $productOptionChildFilter) {
        items {
          id
          parentId
          parent {
            id
            name
            category
          }
          child {
            id
            name
            category
          }
        }
      },
    }
  `;

export const searchProductOptionChildCustoms = /* GraphQL */ `
  query SearchProductOptionChilds(
    $filter: SearchableProductOptionChildFilterInput
    $sort: SearchableProductOptionChildSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductOptionChilds(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        child {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        parent {
          id
          name
          category
        }
      }
      nextToken
      total
    }
  }
`;

export const searchProductChildCustoms = /* GraphQL */ `
  query SearchProductChilds(
    $filter: SearchableProductChildFilterInput
    $sort: SearchableProductChildSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductChilds(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        child {
          id
          name
          status
          serial
          createdAt
          updatedAt
        }
        parent {
          id
          name
          createdAt
          productOption {
            id
            name
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const newProduct = `query newProduct {
  listAccounts(filter: null) {
    items {
      id
      name
      status
    }
    nextToken
  },
  listServices(filter: null) {
    items {
      id
      name
      status
      account {
        id
        name
      }
    }
  },
  listProductOptions(filter: null) {
    items {
      id
      name
      category
      status
    }
    nextToken
  },
  listProductCategoryEnum: __type(name: "ProductCategory") {
    enumValues {
      name
    }
  },  
  listProductBillingMethodEnum: __type(name: "ProductBillingMethod") {
    enumValues {
      name
    }
  }, 
  listProductPlatformEnum: __type(name: "ProductPlatform") {
    enumValues {
      name
    }
  }, 
  listProductAppTypeEnum: __type(name: "ProductAppType") {
    enumValues {
      name
    }
  },  
  listProductConnectEnum: __type(name: "ProductConnect") {
    enumValues {
      name
    }
  },
  listProductConversionEnum: __type(name: "ProductConversion") {
    enumValues {
      name
    }
  },
  listProductEncryptionKeyEnum: __type(name: "ProductEncryptionKey") {
    enumValues {
      name
    }
  },
  listProductPurchaseSwapEnum: __type(name: "ProductPurchaseSwap") {
    enumValues {
      name
    }
  },
  listProductFeeMonthlyEnum: __type(name: "ProductFeeMonthly") {
    enumValues {
      name
    }
  },
}
`;

export const newTask = `query newTask($usersLimit: Int, $casesLimit: Int, $casesFilter: ModelCaseFilterInput) {
  searchUsers(limit: $usersLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
    }
  }
  listCases(limit: $casesLimit, filter: $casesFilter) {
    items {
      id
      name
      subject
      status
    }
  }  
}
`;

export const newTaskTemplate = `query newTask($usersLimit: Int) {
  searchUsers(limit: $usersLimit, filter: null) {
    items {
      id
      email
      given_name
      family_name
    }
  }
}
`;

export const searchAccountCustoms = /* GraphQL */ `
  query SearchAccounts(
    $filter: SearchableAccountFilterInput
    $sort: SearchableAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameLegal
        status
        createdAt
        addressMailing
        addressPhysical
        company {
          id
          name
          createdAt
        }
        updatedBy {
          id
          given_name
          family_name
          middle_name
          createdAt
        }
      }
      nextToken
      total
    }
  }
`;

export const searchSite = `query SearchSite(
  $company_filter: SearchableCompanyFilterInput
  $company_sort: SearchableCompanySortInput
  $account_filter: SearchableAccountFilterInput
  $account_sort: SearchableAccountSortInput
  $service_filter: SearchableServiceFilterInput
  $service_sort: SearchableServiceSortInput
  $person_filter: SearchablePersonFilterInput
  $person_sort: SearchablePersonSortInput
  $product_filter: SearchableProductFilterInput
  $product_sort: SearchableProductSortInput
  $case_filter: SearchableCaseFilterInput
  $case_sort: SearchableCaseSortInput
  $message_filter: SearchableMessageFilterInput
  $message_sort: SearchableMessageSortInput
  $comment_filter: SearchableCommentFilterInput
  $comment_sort: SearchableCommentSortInput  
  $note_filter: SearchableNoteFilterInput
  $note_sort: SearchableNoteSortInput    
  $salesrep_filter: SearchableSalesRepFilterInput
  $salesrep_sort: SearchableSalesRepSortInput     
  $limit: Int
) {
  searchCompanys(
    filter: $company_filter
    sort: $company_sort
    limit: $limit
  ) {
    items {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      active
    }
    total
  },
  searchAccounts(
    filter: $account_filter
    sort: $account_sort
    limit: $limit
  ) {
    items {
      id
      name
      premier
      nameLegal
      namePrevious
      status
      ownershipType
      processorId
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert      
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
    }
    total
  },
  searchServices(
    filter: $service_filter
    sort: $service_sort
    limit: $limit
  ) {
    items {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      status
      processorId
      underwritingStatus
      serviceType
      addressPhysical
      addressMailing
      ownershipType
    }
    total
  },
  searchProducts(    
    filter: $product_filter
    sort: $product_sort
    limit: $limit
  ) {
    items {
      id
      name
      description
    }
    total
  },
  searchPersons(
    filter: $person_filter
    sort: $person_sort
    limit: $limit
  ) {
    items {
      id
      given_name
      family_name
      email
    }
    total
  },
  searchCases(
    filter: $case_filter
    sort: $case_sort
    limit: $limit
  ) {
    items {
      id
      subject
      status
      internal
      origin
      type
      dateDue
      priority
      createdAt
      messages {
        nextToken
      }
    }
    total
  },
  searchMessages(
    filter: $message_filter
    sort: $message_sort
    limit: $limit
  ) {
    items {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      bounces
      case {
        id
        name
        status
        internal
        origin
        type
        dateDue
        priority
        createdAt
      }
      comments {
        nextToken
      }
      createdAt
    }
    total
  },
  searchNotes(
    filter: $note_filter
    sort: $note_sort
    limit: $limit
  ) {
    items {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        subject
        status
        internal
        isCompleteInOrder
      }
    }
    nextToken
    total
  },
  searchSalesReps(
    filter: $salesrep_filter
    sort: $salesrep_sort
    limit: $limit
  ) {
    items {
      id
      given_name
      family_name
      cognito_userid
      createdAt
      updatedAt
      owner
    }
    nextToken
    total
  },
  searchComments(
    filter: $comment_filter
    sort: $comment_sort
    limit: $limit
  ) {
    items {
      id
      comment
      message {
        id
        subject
        messageCaseId
      }
      task {
        id
        subject 
      }
      note {
        id
        note
        case {
          id
        }
      }     
    }
    nextToken
    total
  },
}
`;

export const listCompanyServices = `query listCompanyServices(
  $companyId: ID!
  $filter: ModelServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  getCompany(id: $companyId) {
    id
    name
    active
    accounts {
      items {
        id
        name
        status
        services(filter: $filter, limit: $limit, nextToken: $nextToken) {
          items {
            id
            name
            nameLegal
            status
          }
          nextToken
        }
      }
      nextToken
    }
  }
}
`;

export const listCompanyPeople = `query ListPersonCompanys(
  $filter: ModelPersonCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listPersonCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      person {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        createdAt
        description
        premier
        cognito_userid
      }
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        active
      }
    }
    nextToken
  }
}
`;

export const searchPersonCompanys = `
  query searchPersonCompanys(
    $filter: SearchablePersonCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchPersonCompanys(
      filter: $filter,
      limit: $limit,
      nextToken: $nextToken
    ) {
      items {
        id
        person {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          createdAt
          description
          premier
          cognito_userid
        }
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          active
        }
      }
      nextToken
    }
  }
`;

export const searchCaseMessages = `query searchCaseMessages(
  $filter: SearchableMessageFilterInput
  $sort: SearchableMessageSortInput
  $limit: Int
  $nextToken: String
) {
  searchMessages(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      messageAttachmentId
      origin
      createdAt
      updatedAt
      bounces
      person {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        createdAt
        description
        premier
        cognito_userid
        owner
      }
      case {
        id
        name
        status
        internal
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        createdAt
        updatedAt
        cogUsername
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
      }
      owner
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          user {
            id
            email
            given_name
            family_name
            middle_name
            owner
          }
        }
        nextToken
      }
    }
    nextToken
    total
  }
}
`;

export const searchTasksSteps = `query SearchTasks(
  $filter: SearchableTaskFilterInput
  $sort: SearchableTaskSortInput
  $limit: Int
  $nextToken: String
) {
  searchTasks(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      isTemplate
      type
      dateDue
      subject
      internal
      isAvailable
      isCompleteInOrder
      order
      group
      owner
      createdAt
      priority
      status
      hasWorkflow
      case {
        id
        name
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        createdAt
        cogUsername
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
      }
      steps {
        items {
          id
          title
          description
          order
          status
          isAvailable
          owner
          createdAt
        }
        nextToken
      }
    }
    nextToken
    total
  }
}
`;

export const customSearchCaseTemplates = /* GraphQL */ `
  query SearchCaseTemplates(
    $filter: SearchableCaseTemplateFilterInput
    $sort: SearchableCaseTemplateSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseTemplates(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        subject
        status
        internal
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          items {
            id
            isTemplate
            type
            dateDue
            subject
            internal
            isAvailable
            isCompleteInOrder
            owner
            createdAt
            priority
            status
            case {
              id
              name
              subject
              status
              internal
              origin
              type
              dateDue
              priority
              createdAt
              updatedAt
              owner
              team {
                id
                name
                cognito_groupid
                owner
                createdAt
                updatedAt
              }
            }
            user {
              id
              email
              given_name
              family_name
              middle_name
              nickname
              picture
              gender
              birthdate
              zoneinfo
              phone_number
              address
              source
              createdAt
              updatedAt
              cogUsername
              cogUserCreateDate
              cogUserLastModifiedDate
              cogEnabled
              cogUserStatus
              cogEmailVerified
              cogPreferredMfaSetting
              cogUserMFASettingList
              owner
            }
            steps {
              items {
                id
                title
                description
                order
                status
                isAvailable
                owner
                createdAt
              }
              nextToken
            }
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const searchTaskStepsLists = `query SearchTasks(
  $filter: SearchableTaskFilterInput
  $tasksFilter: ModelTaskFilterInput,
  $sort: SearchableTaskSortInput
  $limit: Int
  $nextToken: String
) {
  searchTasks(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      isTemplate
      type
      dateDue
      subject
      internal
      isAvailable
      isCompleteInOrder
      quickNote
      owner
      createdAt
      priority
      status
      hasWorkflow
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        priority
        quickNote
        createdAt
        team {
          id
          name
          createdAt
        }
      }
      user {
        id
        email
        given_name
        family_name
      }
      steps {
        items {
          id
          title
          description
          order
          status
          isAvailable
          owner
          createdAt
        }
        nextToken
      }
    }
    nextToken
    total
  }
  listTaskStatusEnum: __type(name: "TaskStatus") {
    enumValues {
      name
    }
  }
  listUsers(limit: 100) {
    items {
      id
      email
      given_name
      family_name
      tasks(filter: $tasksFilter) {
        items {
          id
          internal
          isTemplate
        }
        nextToken
      }
    }
    nextToken
  }
}
`;

export const searchTaskStepsListCustoms = `query SearchTasks(
  $filter: SearchableTaskFilterInput
  $tasksFilter: ModelTaskFilterInput,
  $sort: SearchableTaskSortInput
  $limit: Int
  $nextToken: String
) {
  searchTasks(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      dateDue
      subject
      internal
      quickNote
      createdAt
      updatedAt
      priority
      status
      isTemplate
      type
      user {
        id
        given_name
        family_name
        middle_name
        createdAt
      }
      steps {
        items {
          id
          title
          description
          status
        }
      }
      case {
        id
        subject
      }
    	taskTemplate {
        id
        subject
      }
      services {
        items {
          service {
            id
            name
            merchantNumber
          }
        }
      }
      salesreps {
        items {
          salesrep {
            id
            given_name
            family_name
          }
        }
      }
    }
    nextToken
    total
  }
  listTaskStatusEnum: __type(name: "TaskStatus") {
    enumValues {
      name
    }
  }
  searchUsers(limit: 100) {
    items {
      id
      email
      given_name
      family_name
      tasks(filter: $tasksFilter) {
        items {
          id
          internal
          isTemplate
        }
        nextToken
      }
    }
    nextToken
  }
}
`;

export const searchNoteComments = `query SearchNotes(
  $filter: SearchableNoteFilterInput
  $sort: SearchableNoteSortInput
  $limit: Int
  $nextToken: String
) {
  searchNotes(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      note
      owner
      createdAt
      updatedAt
      case {
        id
        name
        status
        internal
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        createdAt
        updatedAt
        cogUsername
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          user {
            id
            email
            given_name
            family_name
            middle_name
            owner
          }
        }
        nextToken
      }
    }
    nextToken
    total
  }
}`;

export const searchCaseCustoms = /* GraphQL */ `
  query SearchCases(
    $filter: SearchableCaseFilterInput
    $sort: SearchableCaseSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCases(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
        status
        closedDate
        priority
        quickNote
        createdAt
        person {
          id
          given_name
          family_name
          email
          createdAt
        }
        template {
          id
          subject
          createdAt
        }
        team {
          id
          name
        }
        user {
          id
          given_name
          family_name
        }
        services {
          items {
            service {
              id
              name
            }
          }
        }
      }
      nextToken
      total
    }
    listTeams(filter: null) {
      items {
        id
        name
      }
    }
    listCaseLinkReasonEnum: __type(name: "CaseLinkReason") {
      enumValues {
        name
      }
    }
  }
`;

export const searchCaseLinkCustoms = /* GraphQL */ `
  query SearchCaseLinks(
    $filter: SearchableCaseLinkFilterInput
    $sort: SearchableCaseLinkSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseLinks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reason
        createdAt
        esData
        esSync
        case {
          id
          name
          subject
          status
          type
          createdAt
          template {
            id
            subject
          }
          user {
            id
            given_name
            family_name
          }
        }
        linkCase {
          id
          name
          subject
          status
          type
          createdAt
          template {
            id
            subject
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const searchAtlasUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $alertsFilter: ModelAlertFilterInput
    $alertsLimit: Int
    $alertsSortDirection: ModelSortDirection
    $nextToken: String
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        alerts(filter: $alertsFilter, limit: $alertsLimit, sortDirection: $alertsSortDirection) {
          items {
            id
            owner
            createdAt
            updatedAt
            type
            subject
            body
            link
            ttl
            level
            status
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;

export const listAlertsCustom = /* GraphQL */ `
  query GetUser($id: ID!, $filter: ModelAlertFilterInput, $limit: Int, $nextToken: String) {
    getUser(id: $id) {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      alerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
    listAlertStatusEnum: __type(name: "AlertStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const searchAlertsCustom = /* GraphQL */ `
  query SearchAlerts(
    $filter: SearchableAlertFilterInput
    $sort: SearchableAlertSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAlerts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        type
        subject
        body
        link
        ttl
        level
        status
        user {
          id
          email
          given_name
          family_name
        }
      }
      nextToken
      total
    }
    listAlertStatusEnum: __type(name: "AlertStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const searchCaseTasks = /* GraphQL */ `
  query SearchTasks(
    $filter: SearchableTaskFilterInput
    $sort: SearchableTaskSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTasks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isTemplate
        type
        dateDue
        subject
        internal
        isAvailable
        isCompleteInOrder
        owner
        group
        order
        createdAt
        priority
        quickNote
        status
        dateCompleted
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        steps {
          items {
            id
            title
            description
            order
            status
            isAvailable
            owner
            createdAt
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;

export const getListCaseStatusEnum = `query getCaseStatus {
  listCaseStatusEnum: __type(name: "CaseStatus") {
    enumValues {
      name
    }
  }
}`;

export const getListTaskStatusEnum = `query getTaskStatus {
  listTaskStatusEnum: __type(name: "TaskStatus") {
    enumValues {
      name
    }
  }
}`;

export const searchReportServices = /* GraphQL */ `
query SearchServices(
  $filter: SearchableServiceFilterInput
  $sort: SearchableServiceSortInput
  $limit: Int
  $nextToken: String
) {
  searchServices(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      ownershipType
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      checkServiceVendor
      checkServiceNum
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          portfolio {
            id
            name
          }
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
      }
      products {
        nextToken
      }
      cases {
        nextToken
      }
      tasks {
        nextToken
      }
    }
    nextToken
    total
  }
}
`;

export const searchServiceCustoms = /* GraphQL */ `
  query SearchServices(
    $filter: SearchableServiceFilterInput
    $sort: SearchableServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        nameLegal
        phoneBusiness
        addressPhysical
        merchantNumber
        account {
          id
          name
          createdAt
        }
        updatedBy {
          id
          given_name
          family_name
          createdAt
        }
        cases {
          items {
            id
            case {
              id
              salesreps {
                items {
                  id
                  salesrep {
                    id
                    given_name
                    family_name
                    createdAt
                  }
                }
              }
            }
          }
        }
      }
      nextToken
      total
    }
    listServiceStatusEnum: __type(name: "ServiceStatuse") {
      enumValues {
        name
      }
    }
  }
`;

export const searchPortfoliosWithDetails = /* GraphQL */ `
  query SearchPortfolios(
    $filter: SearchablePortfolioFilterInput
    $sort: SearchablePortfolioSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPortfolios(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services(limit: $limit) {
          items {
            id
            owner
            createdAt
            updatedAt
            service {
              id
              name
              nameLegal
              description
              pilot
              merchantNumber
              email
              website
              phone
              phoneExt
              status
              processorId
              approvalDate
              underwritingStatus
              IPCorp
              serviceType
              bankAccount
              addressPhysical
              addressMailing
              createdAt
              updatedAt
              isRestructured
              nameDba
              processor
              proposalStatementValue
              phoneBusiness
              phoneSupport
              ownershipType
              avgTrxAmount
              totalCashCreditSalesMonthly
              estAvgMcVisaTicketSaleAmount
              volumeMcVisaOutletMonthly
              dateUwResult
              dateContractExt
              uwResult
              dateOpen
              dateClosed
              beta
              businessType
              busSicCode
              busSicCodeDesc
              busProductsSold
              busSalesLimitM
              busTicketAvg
              busTicketMax
              busSwipePct
              busKeyPct
              busWebPct
              busMailPct
              busAgeY
              busAgeM
              busBusToBus
              busBusToCon
              busLocationCnt
              busSeasonOn
              busSeasonM
              busSeasonOpenM
              busSeasonCloseM
              amex
              amexNum
              discover
              discoverNum
              wexVoyagerOn
              wexVoyagerId
              esaId
              ebtFnsNum
              ebtCashOn
              checkServiceVendor
              checkServiceNum
              giftVendor
              giftVendorNum
              debitPinOn
              cashCreditSalesM
              mcVisaSaleAvg
              mcVisaVolM
              checksCntAvgM
              owner
              closeRequested
              closeDate
              closeReason
              closeReasonDetails
              closeEtfAmountRes
              closeCancelFee
              closeResReportDate
              closeEtfAmount
              closeEtfAdjust
              closeEtfRefundAmount
              closeEtfRefundDate
              closeEtfChargedDate
              closeEtfWaiveReason
              closeEtfWaiveOther
              closeResReportRefundDate
              dateFirstProcessing
              dateSubmitted
              account {
                id
                name
                nameLegal
                namePrevious
                status
                premier
                createdAt
                ownershipType
                processorId
                approvalDate
                underwritingStatus
                nameDba
                phoneBusiness
                phoneSupport
                phoneFax
                ein
                alert
                IPCorp
                addressMailing
                bankAccount
                addressPhysical
                accountCompanyId
                owner
                updatedAt
                company {
                  id
                  name
                  premier
                  email
                  website
                  phone
                  phoneExt
                  alertMessage
                  IPCorp
                  active
                  updatedAt
                  createdAt
                  owner
                }
              }
              portfolios {
                nextToken
              }
              serviceProduct {
                id
                name
                description
                status
                billingMethod
                serial
                platform
                appType
                connect
                conversion
                encryptionKey
                purchaseSwap
                feeMonthly
                cashDiscount
                owner
                virtualTerminal
                accountVault
                recurring
                customerSignUp
                authNetEmulator
                multMerchantMultiDeposit
                multiMerchantNumber
                notesComments
                setupFee
                perItemFee
                terminalOrTsysId
                midV
                storeNumber
                url
                usernames
                gatewayId
                vendorContactNotes
                conversionSetupCost
                soldAmount
                warrantyReplacement
                replacementDate
                isPinPad
                pinPadPurchaseAmount
                FPPPinMonthlyFee
                pabx
                staticIp
                dns1
                gatewayIp
                subnet
                dns2
                secureFileCheck
                securityLevel
                tipLine
                counterTip
                serverNumer
                autoCloseTime
                giftCardProvider
                ebt
                avs
                checkProviderNumber
                fraud
                merchantNumber
                purchaseCard
                taxId
                downloadPhone
                portNumber
                deviceId
                emvSmartCard
                nfc
                autoClose
                giftCards
                internalPinPad
                checkServices
                cvv2
                multiMerchant
                invoiceNumber
                customerCode
                createdAt
                updatedAt
              }
              products {
                nextToken
              }
              cases {
                items {
                  id
                  owner
                  createdAt
                  updatedAt      
                  service {
                    id
                    name             
                    merchantNumber             
                    status              
                    approvalDate             
                    createdAt
                    updatedAt
                    isRestructured                                    
                    account {
                      id
                      name
                      status
                      createdAt
                      approvalDate              
                      updatedAt
                    }
                  }
                  case {
                    id
                    name
                    subject
                    status
                    internal
                    isCompleteInOrder
                    origin
                    type
                    dateDue
                    priority
                    quickNote
                    createdAt
                    updatedAt
                    owner
                    rushReason
                  }                  
                }
                nextToken
              }
              tasks {
                nextToken
              }
              closeEtfWaiveAppover {
                id
                email
                given_name
                family_name
                middle_name
                nickname
                picture
                gender
                birthdate
                zoneinfo
                phone_number
                address
                source
                IPCorp
                internal
                TaskSaveAsTemplate
                CaseSaveAsTemplate
                createdAt
                updatedAt
                cogUsername
                cogUserCreateDate
                cogUserLastModifiedDate
                cogEnabled
                cogUserStatus
                cogEmailVerified
                cogPreferredMfaSetting
                cogUserMFASettingList
                owner
              }
            }
            portfolio {
              id
              name
              description
              premier
              status
              owner
              createdAt
              updatedAt
              services {
                nextToken
              }
            }
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const searchCaseServicesDetails= /* GraphQL */ `
  query SearchCaseServices(
    $filter: SearchableCaseServiceFilterInput
    $sort: SearchableCaseServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt      
        service {
          id
          name             
          merchantNumber             
          status              
          approvalDate             
          createdAt
          updatedAt
          isRestructured                                    
          account {
            id
            name
            status
            createdAt
            approvalDate              
            updatedAt
          }
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
        }                  
      }
      nextToken
      total
    }
  }
`;

export const searchProductServicesCustom = /* GraphQL */ `
  query SearchProductServices(
    $filter: SearchableProductServiceFilterInput
    $sort: SearchableProductServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        service {
          id
          name
        }
        product {
          id
          name
          cashDiscount
          billingMethod
          billToService {
            id
            name
            merchantNumber
            approvalDate
            isRestructured
            proposalStatementValue
            avgTrxAmount
            processor
            status
            account {
              id
              name
              company {
                id
                name
              }
            }
          }
          productOption {
            id
            name
            category
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const listCaseAccountsCustom = /* GraphQL */ `
  query ListCaseAccounts(
    $filter: ModelCaseAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          person {
            id
            given_name
            family_name
            email
            createdAt
          }
          template {
            id
            subject
            createdAt
          }
          team {
            id
            name
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
    }
  }
`;

export const searchCaseAccountsCustom = /* GraphQL */ `
  query SearchCaseAccounts(
    $filter: SearchableCaseAccountFilterInput
    $sort: SearchableCaseAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          createdAt
          updatedAt
        }
        case {
          id
          name
          subject
          status
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          person {
            id
            given_name
            family_name
            email
            createdAt
          }
          template {
            id
            subject
            createdAt
          }
          team {
            id
            name
          }
          user {
            id
            given_name
            family_name
          }
          services (limit: 1, sortDirection: ASC) {
              items {
                  service {
                      id
                      name
                      nameLegal
                      merchantNumber
                      createdAt
                  }
              }
          }
        }
      }
      nextToken
      total
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const searchCaseCompanysCustom = /* GraphQL */ `
  query SearchCaseCompanys(
    $filter: SearchableCaseCompanyFilterInput
    $sort: SearchableCaseCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          person {
            id
            given_name
            family_name
            email
            createdAt
          }
          template {
            id
            subject
            createdAt
          }
          team {
            id
            name
          }
          user {
            id
            given_name
            family_name
          }
          services (limit: 1, sortDirection: ASC) {
              items {
                  service {
                      id
                      name
                      nameLegal
                      merchantNumber
                      createdAt
                  }
              }
          }
        }
      }
      nextToken
      total
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const searchCaseProductsCustom = /* GraphQL */ `
  query SearchCaseProducts(
    $filter: SearchableCaseProductFilterInput
    $sort: SearchableCaseProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          terminalOrTsysId
          midV
          replacementDate
          merchantNumber
          createdAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          rushReason
          template {
            id
            name
            subject
            createdAt
          }
          user {
            id
            email
            given_name
            family_name
            createdAt
          }
          person {
            id
            given_name
            family_name
          }
          team {
            id
            name
          }
          services (limit: 1, sortDirection: ASC) {
              items {
                  service {
                      id
                      name
                      nameLegal
                      merchantNumber
                      createdAt
                  }
              }
          }
        }
      }
      nextToken
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const listCaseSalesRepsCustom = /* GraphQL */ `
  query ListCaseSalesReps(
    $filter: ModelCaseSalesRepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseSalesReps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          template {
            id
            name
            subject
            createdAt
            updatedAt
            owner
          }
          user {
            id
            email
            given_name
            family_name
            createdAt
            updatedAt
            cogUsername
            cogUserCreateDate
            cogUserLastModifiedDate
            cogEnabled
            cogUserStatus
            cogEmailVerified
            cogPreferredMfaSetting
            cogUserMFASettingList
            owner
          }                   
        }
      }
      nextToken
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const searchCaseSalesRepsCustom = /* GraphQL */ `
  query SearchCaseSalesReps(
    $filter: SearchableCaseSalesRepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseSalesReps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          template {
            id
            name
            subject
            createdAt
            updatedAt
            owner
          }
          user {
            id
            email
            given_name
            family_name
            createdAt
            updatedAt
            cogUsername
            cogUserCreateDate
            cogUserLastModifiedDate
            cogEnabled
            cogUserStatus
            cogEmailVerified
            cogPreferredMfaSetting
            cogUserMFASettingList
            owner
          }                   
        }
      }
      nextToken
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const listCaseServicesCustom = /* GraphQL */ `
  query ListCaseServices(
    $filter: ModelCaseServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          person {
            id
            given_name
            family_name
            email
            createdAt
          }
          template {
            id
            subject
            createdAt
          }
          team {
            id
            name
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
    }
  }
`;

export const listTaskAccountsCustom = /* GraphQL */ `
  query ListTaskAccounts(
    $filter: ModelTaskAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        task {
          id
          subject
          createdAt
          status
          case {
            id
            subject
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
    }
  }
`;

export const searchTaskAccountsCustoms = /* GraphQL */ `
  query SearchTaskAccounts(
    $filter: SearchableTaskAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        esData
        task {
          id
          subject
          createdAt
          status
          case {
            id
            subject
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
    }
  }
`;

export const listDashboardTasks = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        dateDue
        subject
        priority
        status
        dateCompleted
        case {
          id
          subject
          isCompleteInOrder
          team {
            name
          }
        }
        user {
          id
          given_name
          family_name
          cogUsername
        }
      }
      nextToken
    }
  }
`;

export const searchDashboardTasks = `query SearchTasks(
  $filter: SearchableTaskFilterInput
  $sort: SearchableTaskSortInput
  $limit: Int
  $nextToken: String
) {
  searchTasks(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      dateDue
      subject
      priority
      status
      dateCompleted
      subject
      case {
        id
        subject
        isCompleteInOrder
        team {
          name
        }
        services {
          items {
            service {
              id
              name
            }
          }
        }
      }
      user {
        id
        given_name
        family_name
        cogUsername
      }
    }
    nextToken
    total
  }
}
`;

export const listAttachmentTypeEnum = `
  query listAttachmentTypeEnum {
    listAttachmentTypeEnum: __type(name: "AttachmentType") {
      enumValues {
        name
      }
    },
  }
`;


export const searchCaseAttachments = `
  query searchRelations(
    $filter: SearchableRelationFilterInput
    $sort: SearchableRelationSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchRelations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fromModelType
        toModelType
        createdAt
        esData
        attachment {
          id
          name
          description
          type
          createdAt
          s3Path
          internal
          isDeleted
          updatedBy {
            id
            given_name
            family_name
            createdAt
          }
        }
        case {
          id
          name
          subject
        }
        updatedBy {
          id
          given_name
          family_name
          createdAt
        }
      }
      nextToken
      total
    }
  }
`;

export const searchUsers = `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        given_name
        family_name
      }
      nextToken
      total
    }
  }
`;

export const searchAccountServiceCustoms = /* GraphQL */ `
  query SearchServices(
    $filter: SearchableServiceFilterInput
    $sort: SearchableServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        nameLegal
        phoneBusiness
        addressPhysical
        merchantNumber
        account {
          id
          name
          createdAt
        }
        updatedBy {
          id
          given_name
          family_name
          createdAt
        }
        cases {
          items {
            id
            case {
              id
              salesreps {
                items {
                  id
                  salesrep {
                    id
                    given_name
                    family_name
                    createdAt
                  }
                }
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const listAccountServices = /* GraphQL */ `
  query ListServices(
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        nameLegal
        phoneBusiness
        addressPhysical
        merchantNumber
        account {
          id
          name
          createdAt
        }
        updatedBy {
          id
          given_name
          family_name
          createdAt
        }
        cases {
          items {
            id
            case {
              id
              salesreps {
                items {
                  id
                  salesrep {
                    id
                    given_name
                    family_name
                    createdAt
                  }
                }
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const caseTargetSearchSalesReps = /* GraphQL */ `
  query SearchSalesReps(
    $filter: SearchableSalesRepFilterInput
    $sort: SearchableSalesRepSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchSalesReps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        given_name
        family_name
        email
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const caseTargetSearchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        status
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const caseTargetSearchServices = /* GraphQL */ `
  query SearchServices(
    $filter: SearchableServiceFilterInput
    $sort: SearchableServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const caseTargetSearchAccounts = /* GraphQL */ `
  query SearchAccounts(
    $filter: SearchableAccountFilterInput
    $sort: SearchableAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const caseTargetSearchCompanys = /* GraphQL */ `
  query SearchCompanys(
    $filter: SearchableCompanyFilterInput
    $sort: SearchableCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        updatedAt
        createdAt
      }
      nextToken
      total
    }
  }
`;

export const searchCompanyCustoms = /* GraphQL */ `
  query SearchCompanys(
    $filter: SearchableCompanyFilterInput
    $sort: SearchableCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
      }
      nextToken
      total
    }
  }
`;

export const getServiceAccount = /* GraphQL */ `
  query GetService($id: ID!) {
    getService(id: $id) {
      id
      account {
        id
      }
      updatedBy {
        id
      }
    }
  }
`;

export const searchCaseServicesCustom = /* GraphQL */ `
  query searchCaseServices(
    $filter: SearchableCaseServiceFilterInput
    $sort: SearchableCaseServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseServices(
      filter: $filter,
      sort: $sort,
      limit: $limit,
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          person {
            id
            given_name
            family_name
            email
            createdAt
          }
          template {
            id
            subject
            createdAt
          }
          team {
            id
            name
          }
          user {
            id
            given_name
            family_name
          }
        }
      }
      nextToken
    }
    listCaseStatusEnum: __type(name: "CaseStatus") {
      enumValues {
        name
      }
    }
  }
`;


export const searchCommentsCustoms = /* GraphQL */ `
  query SearchComments(
    $filter: SearchableCommentFilterInput
    $sort: SearchableCommentSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchComments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          createdAt
          updatedAt
        }
        user {
          id
          given_name
          family_name
          owner
        }
        updatedBy {
          id
          given_name
          family_name
          createdAt
          updatedAt
          owner
        }
        task {
          id
          isTemplate
          subject
          createdAt
          updatedAt
        }
        message {
          id
          sesMessageId
          subject
          messageCaseId
          replyToMessageId
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          task {
            id
            isTemplate           
            subject           
            createdAt
            updatedAt            
          }
          service {
            id
            name
          }
          createdAt
          updatedAt
          owner
        }
        comments {
          items {
            id
            comment
            createdAt
            updatedAt
            user {
              id
              given_name
              family_name              
            }
          }
          nextToken
        }
        note {
          id
          note
          createdAt
          updatedAt
          case {
            id
            subject
          }
        }
      }
      nextToken
      total
    }
  }
`;

export const searchCaseTemplatesHasWorkflows = /* GraphQL */ `
  query searchCaseTemplates(
    $filter: SearchableCaseTemplateFilterInput
    $sort: SearchableCaseTemplateSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseTemplates(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
      }
    }
  }
`;